import { useEffect, useRef } from 'react';
import { Message } from './Message';
import type { ChatMessage } from '../lib/types';

interface Props {
  messages: ChatMessage[];
  partial: string | null;
  error: string | null;
}

export function MessageList({ messages, partial, error }: Props) {
  const endRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [messages, partial]);

  const empty = messages.length === 0 && partial === null && !error;

  return (
    <div className="space-y-3 max-w-3xl mx-auto">
      {empty && (
        <div className="text-center text-gray-500 mt-16 text-sm px-4">
          Задайте вопрос ниже. Effort, модель и пресеты — кнопка «параметры».
        </div>
      )}
      {messages.map((m, i) => (
        <Message key={i} message={m} />
      ))}
      {partial !== null && (
        <Message message={{ role: 'assistant', content: partial }} partial />
      )}
      {error && (
        <div className="text-red-400 bg-red-950/40 border border-red-900 p-3 rounded-lg text-sm">
          {error}
        </div>
      )}
      <div ref={endRef} />
    </div>
  );
}
